import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "editable-chip-dropdown" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    class: "mt-4"
};
import { ref, computed, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditableChipDropdown',
    props: {
        modelValue: {
            type: [String, Number],
            required: true,
        },
        options: {
            type: Array,
            required: true,
            validator: (value) => {
                return value.every((opt) => opt.hasOwnProperty("value") && opt.hasOwnProperty("label"));
            },
        },
        color: {
            type: String,
            default: "primary",
        },
        colorMap: {
            type: Object,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: null,
        },
        dialogTitle: {
            type: String,
            default: "Confirm Change",
        },
        dialogMessage: {
            type: String,
            default: null,
        },
        inputFieldsConfig: {
            type: Object,
            default: () => ({}),
        },
        apiEndpoint: {
            type: Function,
            required: true,
        },
        getRequestPayload: {
            type: Function,
            default: (newValue, formData) => ({ value: newValue, ...formData }),
        },
        displayText: {
            type: String,
            default: null,
        },
    },
    emits: ["update:modelValue", "change", "change-confirmed", "change-cancelled"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const dropdownOpen = ref(false);
        const showConfirmDialog = ref(false);
        const isSubmitting = ref(false);
        const formData = ref({});
        const pendingValue = ref(null);
        const errorMsg = ref(null);
        const currentColor = computed(() => {
            return props.colorMap[props.modelValue] || props.color;
        });
        const displayValue = computed(() => {
            const option = props.options.find((opt) => opt.value === props.modelValue);
            return option ? option.label : props.displayText || props.modelValue;
        });
        const requiresInputFields = computed(() => {
            if (!pendingValue.value || !props.inputFieldsConfig)
                return false;
            return props.inputFieldsConfig[pendingValue.value] !== undefined;
        });
        const inputFields = computed(() => {
            if (!requiresInputFields.value)
                return [];
            return props.inputFieldsConfig[pendingValue.value] || [];
        });
        const isFormValid = computed(() => {
            if (!requiresInputFields.value)
                return true;
            return inputFields.value.every((field) => {
                if (field.required && !formData.value[field.key])
                    return false;
                if (field.rules) {
                    return field.rules.every((rule) => {
                        const result = typeof rule === "function" ? rule(formData.value[field.key]) : rule;
                        return result === true || typeof result === "string";
                    });
                }
                return true;
            });
        });
        function onOptionSelected(option) {
            if (option.value === props.modelValue) {
                dropdownOpen.value = false;
                return;
            }
            pendingValue.value = option.value;
            formData.value = {};
            showConfirmDialog.value = true;
            dropdownOpen.value = false;
        }
        function cancelChange() {
            showConfirmDialog.value = false;
            pendingValue.value = null;
            formData.value = {};
            emit("change-cancelled");
        }
        async function confirmChange() {
            if (!isFormValid.value)
                return;
            isSubmitting.value = true;
            try {
                const payload = props.getRequestPayload(pendingValue.value, formData.value);
                await props.apiEndpoint(payload);
                emit("update:modelValue", pendingValue.value);
                emit("change", pendingValue.value, formData.value);
                emit("change-confirmed", pendingValue.value, formData.value);
                showConfirmDialog.value = false;
                pendingValue.value = null;
                formData.value = {};
            }
            catch (error) {
                errorMsg.value = "Failed to update value. Please try again.";
            }
            finally {
                isSubmitting.value = false;
            }
        }
        watch(() => props.modelValue, () => {
            // Reset form data when value changes externally
            formData.value = {};
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_menu, {
                    modelValue: dropdownOpen.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((dropdownOpen).value = $event)),
                    disabled: props.disabled
                }, {
                    activator: _withCtx(({ props: menuProps }) => [
                        _createVNode(_component_v_chip, _mergeProps(menuProps, {
                            color: currentColor.value,
                            size: "small",
                            "prepend-icon": props.icon,
                            class: { 'cursor-pointer': !__props.disabled },
                            onClick: _cache[0] || (_cache[0] = ($event) => (!__props.disabled && (dropdownOpen.value = true)))
                        }), {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(displayValue.value) + " ", 1),
                                (!__props.disabled)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        size: "small",
                                        class: "ml-1"
                                    }, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                _createTextVNode("mdi-menu-down", -1)
                                            ]))]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }, 16, ["color", "prepend-icon", "class"])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: option.value,
                                        value: option.value,
                                        onClick: ($event) => (onOptionSelected(option))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(option.label), 1)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1032, ["value", "onClick"]));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_v_dialog, {
                    modelValue: showConfirmDialog.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showConfirmDialog).value = $event)),
                    "max-width": "500",
                    persistent: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                                (errorMsg.value)
                                    ? (_openBlock(), _createBlock(_component_v_alert, {
                                        key: 0,
                                        type: "error",
                                        variant: "tonal",
                                        closable: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(errorMsg.value), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_card_title, null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.dialogTitle || "Confirm Change"), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                        (props.dialogMessage)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.dialogMessage), 1))
                                            : _createCommentVNode("", true),
                                        (requiresInputFields.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputFields.value, (field) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: field.key,
                                                        class: "mb-4"
                                                    }, [
                                                        (field.type === 'text')
                                                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                                key: 0,
                                                                modelValue: formData.value[field.key],
                                                                "onUpdate:modelValue": ($event) => ((formData.value[field.key]) = $event),
                                                                label: field.label,
                                                                placeholder: field.placeholder,
                                                                required: field.required,
                                                                rules: field.rules || [],
                                                                density: "comfortable"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "required", "rules"]))
                                                            : _createCommentVNode("", true),
                                                        (field.type === 'date')
                                                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                                                key: 1,
                                                                modelValue: formData.value[field.key],
                                                                "onUpdate:modelValue": ($event) => ((formData.value[field.key]) = $event),
                                                                label: field.label,
                                                                type: "date",
                                                                placeholder: field.placeholder,
                                                                required: field.required,
                                                                rules: field.rules || [],
                                                                density: "comfortable"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "required", "rules"]))
                                                            : (field.type === 'textarea')
                                                                ? (_openBlock(), _createBlock(_component_v_textarea, {
                                                                    key: 2,
                                                                    modelValue: formData.value[field.key],
                                                                    "onUpdate:modelValue": ($event) => ((formData.value[field.key]) = $event),
                                                                    label: field.label,
                                                                    placeholder: field.placeholder,
                                                                    required: field.required,
                                                                    rules: field.rules || [],
                                                                    rows: "3",
                                                                    "auto-grow": ""
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder", "required", "rules"]))
                                                                : (field.type === 'select')
                                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                                        key: 3,
                                                                        modelValue: formData.value[field.key],
                                                                        "onUpdate:modelValue": ($event) => ((formData.value[field.key]) = $event),
                                                                        label: field.label,
                                                                        items: field.options || [],
                                                                        "item-title": field.optionLabel,
                                                                        "item-value": field.optionValue,
                                                                        placeholder: field.placeholder,
                                                                        required: field.required,
                                                                        rules: field.rules || [],
                                                                        density: "comfortable"
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "items", "item-title", "item-value", "placeholder", "required", "rules"]))
                                                                    : _createCommentVNode("", true)
                                                    ]));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                            variant: "text",
                                            onClick: cancelChange
                                        }, {
                                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                    _createTextVNode("Cancel", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_btn, {
                                            color: "primary",
                                            variant: "flat",
                                            disabled: !isFormValid.value,
                                            loading: isSubmitting.value,
                                            onClick: confirmChange
                                        }, {
                                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                    _createTextVNode(" Confirm ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["disabled", "loading"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
